import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaSearch,  FaSignOutAlt, FaTimes } from "react-icons/fa";
import { FaBars } from "react-icons/fa6";
import { removeCookie } from "../../lib/auth_base/cookie_auth";

import "./header.css";
import logout from "../../ui/logout";
import { siteLogout } from "../../lib/auth_base/auth-service";

//
const Header = ({
  is_home,
  is_logged,
  user,
}: {
  is_home?: boolean;
  is_logged?: boolean;
  user?: any;
}) => {

  const router = useNavigate();
  const [togged, setTogged] = React.useState(false);
  const do_tog = () => {
    setTogged(!togged);
  };

  
  const doLogout = ()=> {
    setTimeout(async() => {
    siteLogout();
          window.location.href = "/";
    },1000)

  }

  
  const [query, setQuery] = React.useState<string | any>(null);
  const doSearch = () => {
    if (!query) {
      alert("Type in your query");
      return;
    }
  router(`/search/q/${encodeURIComponent(query)}`,{replace:true});
  };

  return (

    <React.Fragment>
      <header
        className={
          is_home ? "landing-header absolute" : "landing-header relative"
        }
      >
        <div className="header-inner">
          <div className="logo">
            <Link to="/">Hi Gorgeous</Link>
          </div>
          <div className="spacer"></div>
          <div className="main-nav">
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/shop">Shop</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>   
              
            {is_logged && (<li>
              <Link to="#" onClick={doLogout}>
                <FaSignOutAlt className="pr5" /> Log Out
              </Link></li>
            )}
              <li>
                <Link to="/search">
                  <FaSearch className="pr5" /> Search
                </Link>
              </li>
            </ul>
          </div>
          <div className="spacer"></div>
          <div className="header-acts">
       
            
            <span className="mobile-hash">
              <Link to="#" onClick={do_tog}>
                {togged ? <FaTimes /> : <FaBars />}
              </Link>
            </span>
          </div>
        </div>
      </header>
      <div className="mobile-panel" style={{ height: togged ? "100%" : "0" }}>
        <div className="mobile-nav">
          <div className="mobile-header-inner">
            <div className="logo">
              <Link to="/" onClick={do_tog}>
                Hi Gorgeous
              </Link>
            </div>
            <div className="spacer"></div>
            <span className="mobile-hash">
              <Link to="#" onClick={do_tog}>
                {togged ? <FaTimes /> : <FaBars />}
              </Link>
            </span>
          </div>
          <ul>
            <li>
              <div className="search-cover">
                <div className="site-search-input-container">
                  <input
                    type="search"
                    placeholder="Search Products..."
                    name="query"
                    onChange={(e) => setQuery(e.target.value)}
                    className="site-search-input"
                  />
                  {query && query.length > 0 && (
                    <button
                      aria-label="Search"
                      onClick={doSearch}
                      className="search-btn"
                    >
                      <FaSearch />
                    </button>
                  )}
                </div>
              </div>
            </li>
            <li>
              <Link to="/" onClick={do_tog}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={do_tog}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/products" onClick={do_tog}>
                Products
              </Link>
            </li>
            <li>
              <Link to="/contact-us" onClick={do_tog}>
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/shop" onClick={do_tog}>
                Shop
              </Link>
            </li>
            <li>
              <Link to="/search" onClick={do_tog}>
                Search Products
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={do_tog}>
                Frequently Asked Questions
              </Link>
            </li>
             {is_logged && (
            <li> 
              <Link to="#" onClick={doLogout}>
                <FaSignOutAlt className="pr5" /> Log Out
              </Link>
           
            </li>)} 
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
